import { Route, Routes, useLocation } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from "react-transition-group";
import './App.css';
import axios from 'axios';
import { message } from 'antd';
import Confirmation from './pages/Confirmation';
import { ScreenClassProvider } from 'react-grid-system';
import Success from './pages/Success';
import ChooseRole from './pages/ChooseRole';
import IndividualBooking from './pages/IndividualBooking';

// CHANGE IN PRODUCTION
axios.defaults.baseURL = '/';

function App() {
  const location = useLocation();
  const [messageApi, contextHolder] = message.useMessage();

  return (
    <ScreenClassProvider>
      <div className='App' style={{ paddingTop: "20px" }}>
        {contextHolder}
        <SwitchTransition>
          <CSSTransition key={location.key}
            classNames="fade" timeout={300}>
            <Routes location={location}>
              <Route path="/" element={<ChooseRole messageApi={messageApi} />} />
              <Route path="/individual" element={<IndividualBooking messageApi={messageApi} />} />
              <Route path="/confirm" element={<Confirmation messageApi={messageApi} />} />
              <Route path="/success" element={<Success messageApi={messageApi} />} />
            </Routes>
          </CSSTransition>
        </SwitchTransition>
      </div>
    </ScreenClassProvider>
  );
}

export default App;
